import { defineMessages } from 'react-intl';

const messages = defineMessages({
  advancedFit: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.advancedFit',
    defaultMessage: 'Advanced fit',
  },
  advancedFitDescription: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.advancedFitDescription',
    defaultMessage:
      'Workout 5+ times per week, superior motor skill, run more than 10km in a row, perfectly disciplined in training and eating, excellent health.',
  },
  almostFit: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.almostFit',
    defaultMessage: 'Almost fit',
  },
  almostFitDescription: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.almostFitDescription',
    defaultMessage:
      'Sedentary lifestyle, good health but will get worse with this lifestyle, without/rarely included in exercise recently.',
  },
  description: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.description',
    defaultMessage: 'Tell us a bit more about your daily habits.',
  },
  fit: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.fit',
    defaultMessage: 'Fit',
  },
  fitDescription: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.fitDescription',
    defaultMessage:
      'Mixed sedentary/physically active lifestyle, did sports and/or exercise before. Do recreation sports and/or exercise 2-3 times per week, very good health.',
  },
  notFit: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.notFit',
    defaultMessage: 'Not fit',
  },
  notFitDescription: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.notFitDescription',
    defaultMessage:
      'True beginner, sedentary lifestyle, risk for physical and metabolic diseases, without any workout for a long time.',
  },
  proFit: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.proFit',
    defaultMessage: 'Pro fit',
  },
  proFitDescription: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.proFitDescription',
    defaultMessage:
      'Physically active lifestyle - fitness/sport enthusiast or professional athlete, workout 4+ times per week, run more than 6km in a row, without health issues, healthy nutritional habits, excellent health.',
  },
  title: {
    id: 'onboardingPages.clientOnboarding.trainingLevel.title',
    defaultMessage: 'What is your training level?',
  },
});

export default messages;
